import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./styles/index.css";
import { loadTranslations } from "./i18n";

loadTranslations().then(() => {
	const root = ReactDOM.createRoot(document.getElementById("root"));
	root.render(<App />);
});
